import React, { FC } from 'react';

import { Icon, IconSize } from 'app/design-system/components/Icon';
import { useTranslation } from 'app/lang';

import dictionary from './ToolbarButtons.dictionary.json';

type ToolbarButtonsProps = {
  muted: boolean;
  pipMode: boolean;
  toggleMuted: VoidFunction;
  togglePictureInPicture: () => void;
  handleClose: VoidFunction;
  pipButtonClassNames: string;
};

const ToolbarButtons: FC<ToolbarButtonsProps> = ({
  muted,
  pipMode,
  toggleMuted,
  togglePictureInPicture,
  handleClose,
  pipButtonClassNames,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <button onClick={togglePictureInPicture}
              title={pipMode ? t(dictionary.pipOff) : t(dictionary.pipOn)}
              type="button"
              data-ga-event="right-broadcastFloatToggle"
              data-ga-event-value={pipMode ? 'On' : 'Off'}
              className={pipButtonClassNames}>
        <Icon icon={pipMode? 'picture-in-picture-close' : 'picture-in-picture-open'}
              size={IconSize.MEDIUM} />
      </button>

      <button onClick={toggleMuted}
              type="button"
              data-ga-event="right-broadcastSoundToggle"
              data-ga-event-value={muted ? 'Off' : 'On'}
              title={muted ? t(dictionary.soundOn) : t(dictionary.soundOff)}>
        <Icon icon={muted ? 'sound-off' : 'sound-on'}
              size={IconSize.MEDIUM} />
      </button>

      <button onClick={handleClose}
              type="button"
              data-ga-event="right-broadcastToggle"
              data-ga-event-value="Off"
              title={t(dictionary.close)}>
        <Icon icon="close-tiny"
              size={IconSize.MEDIUM} />
      </button>
    </>
  );
};

export default ToolbarButtons;
